import { flow, Instance, types } from 'mobx-state-tree';
import { IGenericSpeiPaymentData } from '@containers/checkout/payment-form/types';
import axios from 'axios';
import endpoints from '@configs/endpoints';
import debug from 'debug';

const error = debug('GenericSpeiStore:error');
const speiInitialData = {
  bankName: '',
  clabe: '',
  referenceNumber: '',
  cieAgreementNumber: '',
  amount: '',
  paymentInstruction: '',
  expirationDate: '',
  beneficiaryName: '',
};

const GenericSpeiStore = types
  .model({
    speiReference: types.optional(types.model(speiInitialData), {}),
    flags: types.optional(
      types.model({
        isLoadingSpeiReference: false,
        isSpeiReferenceGenerated: false,
      }),
      {},
    ),
  })
  .views((self) => ({
    get netAmount() {
      return +self.speiReference.amount / 100;
    },
  }))
  .actions((self) => ({
    getSpeiReference: flow(function* (payload: IGenericSpeiPaymentData) {
      if (self.flags.isLoadingSpeiReference) return;

      self.flags.isLoadingSpeiReference = true;
      try {
        const body = {
          paymentLinkId: payload.paymentLinkId,
          payeeFirstName: payload.payeeFirstName,
          payeeLastName: payload.payeeLastName,
          payeeEmail: payload.payeeEmail.trim(),
          payeePhone: payload.payeePhone.replace(/\s/g, ''),
          deviceId: payload.deviceId,
        };
        const { data } = yield axios.post(endpoints.processSpeiPayment, body);
        if (data.error) {
          throw new Error(data.msg);
        }

        self.speiReference = data.speiReference;
        self.flags.isSpeiReferenceGenerated = true;

        // TODO : define GA events for spei
      } catch (e) {
        error(`Error trying init ${payload.partner} spei payment transaction`, e);
        throw e;
      } finally {
        self.flags.isLoadingSpeiReference = false;
      }
    }),
    resetSpeiReference: () => {
      self.flags.isSpeiReferenceGenerated = false;
      self.speiReference = speiInitialData;
    },
  }));

export type IGenericSpeiStore = Instance<typeof GenericSpeiStore>;
export default GenericSpeiStore;
